const getPerformanceDateString = (performanceTime) =>
    new Date(performanceTime + performance.timing.navigationStart).toString();

const getPerformanceNow = () => {
    return window.performance.now();
};

const getPerformanceNowInt = () => Math.round(getPerformanceNow());

export const LogHelper = {
    getPerformanceDateString,
    getPerformanceNow,
    getPerformanceNowInt,
};
